import {Injectable} from '@angular/core';

import 'rxjs/add/operator/toPromise';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {ApiService} from './api.service';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import {Product} from '../model/Entities/Product';
import {Observable} from 'rxjs/Observable';
import {User} from '../model/Entities/User';
import {Filter} from '../model/Helpers/Filter';
import {Contract} from '../model/Entities/Contract';
import {ProductType} from '../model/Entities/ProductType';
import {ProductContent} from '../model/Entities/ProductContent';
import {ProductCategory} from '../model/Entities/ProductCategory';

@Injectable()
export class ProductCategoryService extends ApiService<ProductCategory> {

    protected apiUrl = 'api/product-categories';  // URL to web api

    protected getObjectType(): any {
        return ProductCategory;
    }
}



// WEBPACK FOOTER //
// /app/src/services/product-category.service.ts